<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{title}}<button type="button" class="close"
                           @click.prevent="closeModal()">
        <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <div class="row justify-content-center orange center mb-2">
      <div class="col-1 column"/>
      <div class="col-3"><h6>Question</h6></div>
      <div class="col-3"></div>
      <div class="col-3"><h6>Response</h6></div>
      <div class="col-1 column"/>

    </div>
    <div class="row justify-content-center mb-2" v-for="answer in result.answers"
         :key="answer.organizationPatientSurveyAnswerId">
      <div class="col-1 column"/>
      <div class="col-6 align-self-center">{{ answer.surveyQuestion.title }}</div>
      <div v-if="answer.surveyAnswer" class="col-3 align-self-center">{{ answer.surveyAnswer.name }}</div>
      <div v-if="!answer.surveyAnswer" class="col-3 align-self-center">{{answer.points}}</div>
      <div class="col-1 column"/>
    </div>

    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import moment from 'moment-timezone'

  export default {
    name: 'SurveyResultsModal',

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      results: {
        type: Object
      },

      answers: {
        type: Object
      },

      result: {
        type: Object,
        required: true
      }
    },

    watch: {
    },

    computed: {
      title () {
        if (this.result) {
          const name = this.result.name
          if (name) {
            return 'Survey Responses - ' + name
          }
        }
        return 'Survey Responses'
      }
    },

    methods: {
      closeModal () {
        this.$emit('update:visible', false)
      },

      formatDate (date) {
        if (date) {
          return moment(date).format('MM/DD/YY')
        } else {
          return ''
        }
      }
    }
  }
</script>

<style scoped>

</style>
